import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Divider } from 'primereact/divider';
import { Panel } from 'primereact/panel';
import { Timeline } from 'primereact/timeline';
// next/image removido para compatibilidad con React
import { useTheme } from '../hooks/useTheme';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';

export default function Garantias() {
    const [activeIndex, setActiveIndex] = useState(null);
    const { theme, toggleTheme } = useTheme();

    const warrantyFeatures = [
        {
            title: 'Garantía oficial',
            description: 'Todos nuestros productos cuentan con garantía oficial del fabricante o del vendedor, y cuentan con el respaldo de Laptops.pe',
            icon: 'pi pi-verified',
            severity: 'success'
        },
        {
            title: 'Cobertura completa',
            description: 'Defectos de fabricación y problemas de hardware cubiertos por el fabricante',
            icon: 'pi pi-shield',
            severity: 'info'
        },
        {
            title: 'Plazos extendidos',
            description: 'Varían según la marca, desde 12 hasta 36 meses (especificado en cada producto)',
            icon: 'pi pi-calendar',
            severity: 'warning'
        },
        {
            title: 'Soporte especializado',
            description: 'Nuestro equipo especializado te guiará para verificar el problema y gestionar la garantía',
            icon: 'pi pi-headphones',
            severity: 'help'
        }
    ];

    const warrantyProcess = [
        {
            status: 'Contacto inicial',
            date: 'Día 1',
            icon: 'pi pi-phone',
            color: '#3B82F6',
            description: 'Contacta a nuestro soporte técnico para reportar el problema'
        },
        {
            status: 'Diagnóstico',
            date: 'Días 1-3',
            icon: 'pi pi-search',
            color: '#F59E0B',
            description: 'Revisión y diagnóstico dentro de las 72 horas hábiles'
        },
        {
            status: 'Resolución',
            date: 'Días 4-7',
            icon: 'pi pi-cog',
            color: '#10B981',
            description: 'Cambio inmediato o reparación según corresponda (El tiempo puede extenderse según la complejidad del caso)'
        },
        {
            status: 'Entrega',
            date: 'Final',
            icon: 'pi pi-check-circle',
            color: '#8B5CF6',
            description: 'Producto reparado o reemplazado entregado al cliente'
        }
    ];

    const warrantyTerms = [
        {
            number: '1',
            title: 'Garantía estándar',
            description: 'Todos nuestros productos cuentan con garantía oficial del fabricante o del vendedor, y cuentan con el respaldo de Laptops.pe.',
            icon: 'pi pi-calendar-plus',
            highlight: true
        },
        {
            number: '2',
            title: 'Cambio inmediato',
            description: 'Se hará nota de crédito o cambio del producto, si el equipo falla dentro de los 7 días de haber hecho la compra (previa revisión de soporte técnico).',
            icon: 'pi pi-refresh',
            highlight: true
        },
        {
            number: '3',
            title: 'Tiempo de diagnóstico',
            description: 'La revisión y diagnóstico de los equipos por garantía se realizarán dentro de las 72 horas hábiles después de recibido el equipo.',
            icon: 'pi pi-clock',
            highlight: false
        },
        {
            number: '4',
            title: 'Repuestos y reparación',
            description: 'Para los equipos que requieran solución con cambios de repuestos, dependerá de la disponibilidad del repuesto pudiendo ser de 12 a 20 días útiles.',
            icon: 'pi pi-wrench',
            highlight: false
        },
        {
            number: '5',
            title: 'Comprobante requerido',
            description: 'Es indispensable presentar el comprobante de compra para efectuar el trámite de garantía.',
            icon: 'pi pi-file-check',
            highlight: false
        },
        {
            number: '6',
            title: 'Sellos de garantía',
            description: 'Es indispensable que los equipos no presenten sellos de garantía rotos (no se aceptarán).',
            icon: 'pi pi-ban',
            highlight: false
        },
        {
            number: '7',
            title: 'Manipulación no autorizada',
            description: 'Se perderá la garantía en su totalidad si se encuentran rastros de que los pernos hayan sido manipulados.',
            icon: 'pi pi-exclamation-triangle',
            highlight: false
        },
        {
            number: '8',
            title: 'Repotenciación autorizada',
            description: 'En caso el cliente desee repotenciar alguno de los equipos adquiridos, es necesario que comunique a su ejecutivo de ventas y brinde el modelo y serie del equipo a repotenciar, caso contrario no se validará la garantía si el producto falla en el futuro.',
            icon: 'pi pi-cog',
            highlight: false
        },
        {
            number: '9',
            title: 'Garantía de partes repotenciadas',
            description: 'La garantía de las partes repotenciadas se perderá cuando se hagan los cambios, más no de lo demás.',
            icon: 'pi pi-info-circle',
            highlight: false
        }
    ];

    const exclusions = [
        {
            title: 'Daños por mal uso',
            description: 'Uso inadecuado del producto fuera de las especificaciones',
            icon: 'pi pi-times-circle'
        },
        {
            title: 'Daños físicos',
            description: 'Golpes, caídas o daños por impacto',
            icon: 'pi pi-exclamation-triangle'
        },
        {
            title: 'Manipulación no autorizada',
            description: 'Apertura o modificación sin autorización del fabricante',
            icon: 'pi pi-lock'
        }
    ];

    return (
        <div className={'landing-page theme-' + theme}>
            <Header theme={theme} onToggleTheme={toggleTheme} />
            <div className="surface-ground min-h-screen">
                {/* Hero Section */}
                <div className="surface-section">
                    <div className=" mx-auto px-4">
                        <div className="grid">
                            <div className="col-12">
                                <h1 className="text-3xl lg:text-6xl font-bold text-primary mb-4 line-height-2">
                                    Garantía de Productos y Soporte
                                </h1>
                                <p className="text-xl lg:text-2xl text-700 line-height-3 mb-6">
                                    Todos nuestros productos cuentan con garantía oficial del fabricante o del vendedor, y cuentan con el respaldo de Laptops.pe. 
                                    Porque creemos en la calidad de nuestros productos, tu inversión está protegida.
                                </p>
                                <div className="flex flex-wrap gap-3">
                                    <Badge value="Garantía oficial" severity="success" size="large" />
                                    <Badge value="Soporte especializado" severity="info" size="large" />
                                    <Badge value="12-36 meses" severity="warning" size="large" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" m-4">
                {/* Características principales de la garantía */}
                <div className="mb-6">
                    <Card>
                        <div className="p-0 text-center">
                            <h2 className="text-4xl font-bold text-primary mb-4">¿Qué incluye nuestra garantía?</h2>
                            <div className="grid">
                                {warrantyFeatures.map((feature, index) => (
                                    <div key={index} className="col-12 md:col-6 lg:col-3">
                                        <div className="text-center p-4">
                                            <div className="inline-flex align-items-center justify-content-center w-4rem h-4rem border-circle mb-4">
                                                <i className={`${feature.icon} text-6xl text-cyan-500`}></i>
                                            </div>
                                            <h3 className="text-xl font-semibold text-900 mb-3">{feature.title}</h3>
                                            <p className="text-600 line-height-3 mb-3">{feature.description}</p>
                                            <Badge value={feature.severity === 'success' ? 'Incluido' : feature.severity === 'info' ? 'Completa' : feature.severity === 'warning' ? 'Extendida' : 'Experto'} severity={feature.severity} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Card>
                </div>

                {/* Proceso de garantía */}
                <div className="mb-6">
                    <Card>
                        <div className="p-0 text-center">
                            <h2 className="text-4xl font-bold text-primary mb-4">Proceso de garantía</h2>
                            <p className="text-lg text-700 mb-6 line-height-3">
                                Nuestro proceso está diseñado para resolver tu problema de manera rápida y eficiente:
                            </p>

                            <Timeline 
                                value={warrantyProcess} 
                                align="alternate" 
                                className="customized-timeline"
                                marker={(item) => (
                                    <span 
                                        className="flex w-3rem h-3rem align-items-center justify-content-center text-white border-circle z-1 shadow-1"
                                        style={{ backgroundColor: item.color }}
                                    >
                                        <i className={item.icon}></i>
                                    </span>
                                )}
                                content={(item) => (
                                    <Card className="mt-3">
                                        <div className="p-3">
                                            <h4 className="font-semibold text-lg mb-2 text-900">{item.status}</h4>
                                            <Badge value={item.date} className="mb-2" />
                                            <p className="text-600 m-0 line-height-3">{item.description}</p>
                                        </div>
                                    </Card>
                                )}
                            />
                        </div>
                    </Card>
                </div>

                {/* Términos de garantía */}
                <div className="mb-6">
                    <Card>
                        <div className="p-0 text-center">
                            <h2 className="text-4xl font-bold text-primary mb-4">Términos de la garantía</h2>

                            <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} multiple>
                                {warrantyTerms.map((term, index) => (
                                    <AccordionTab 
                                        key={index}
                                        header={
                                            <div className="flex align-items-center gap-3">
                                                <div className={`inline-flex align-items-center justify-content-center w-2rem h-2rem ${term.highlight ? 'bg-cyan-500' : 'bg-gray-500'} text-white border-circle font-bold`}>
                                                    {term.number}
                                                </div>
                                                <i className={`${term.icon} ${term.highlight ? 'text-primary' : 'text-600'}`}></i>
                                                <span className={`font-semibold ${term.highlight ? 'text-primary' : 'text-900'}`}>{term.title}</span>
                                                {term.highlight && <Badge value="Importante" severity="success" className="ml-2" />}
                                            </div>
                                        }
                                    >
                                        <div className="p-4">
                                            <div className={`${term.highlight ? ' border-left-3 border-primary' : 'surface-100'} border-round p-4`}>
                                                <p className="text-700 line-height-3 m-0">{term.description}</p>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                ))}
                            </Accordion>
                        </div>
                    </Card>
                </div>

                {/* Exclusiones */}
                <div className="mb-6">
                    <Card>
                        <div className="p-0 text-center">
                            <h2 className="text-4xl font-bold text-900 mb-6">Exclusiones de garantía</h2>
                            <p className="text-lg text-700 mb-6 line-height-3">
                                Es importante conocer qué situaciones no están cubiertas por la garantía:
                            </p>
                            <div className="grid">
                                {exclusions.map((exclusion, index) => (
                                    <div key={index} className="col-12 md:col-4">
                                        <div className="surface-100 border-round p-4 h-full text-center">
                                            <div className="inline-flex align-items-center justify-content-center w-3rem h-3rem bg-red-100 border-circle mb-4">
                                                <i className={`${exclusion.icon} text-xl text-red-500`}></i>
                                            </div>
                                            <h3 className="text-lg font-semibold text-900 mb-3">{exclusion.title}</h3>
                                            <p className="text-600 line-height-3">{exclusion.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-4 p-3 border-round border-left-3 bg-orange-100 border-orange-500">
                                <p className="text-orange-800 m-0">
                                    <i className="pi pi-exclamation-triangle text-orange-500 mr-2"></i>
                                    <strong>Importante:</strong> Para mantener la validez de tu garantía, sigue las instrucciones del fabricante y evita estas situaciones
                                </p>
                            </div>
                        </div>
                    </Card>
                </div>

                {/* Información de contacto para garantía */}
                <div className="mb-6">
                    <Card>
                        <div className="p-6 text-center">
                            <h2 className="text-4xl font-bold text-900 mb-4">¿Necesitas activar tu garantía?</h2>
                            <p className="text-xl text-700 mb-6 line-height-3">
                                Nuestro equipo de soporte técnico especializado está listo para ayudarte
                            </p>
                            
                            {/* Imagen de soporte técnico */}
                            <div className="mb-6">
                                <div className="surface-100 border-round-xl p-1">
                                    <img 
                                        src="/imagenes/soporte.png" 
                                        alt="Soporte" 
                                        width="1312" 
                                        height="704"
                                        className="w-full h-auto border-round"
                                        style={{ maxWidth: '100%', height: 'auto' }}
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </div>
                            </div>

                            {/* Grid de acciones de garantía deshabilitado temporalmente */}
                            
                            <div className="grid mt-4">
                                <div className="col-12 md:col-6">
                                    <div className="p-3 bg-green-800 border-round border-left-3 border-green-500">
                                        <p className="text-white m-0">
                                            <i className="pi pi-clock text-green-500 mr-2"></i>
                                            <strong>Diagnóstico rápido:</strong> 72 horas hábiles máximo
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12 md:col-6">
                                    <div className="p-3 bg-blue-800 border-round border-left-3 border-blue-500">
                                        <p className="text-white m-0">
                                            <i className="pi pi-refresh text-blue-500 mr-2"></i>
                                            <strong>Cambio inmediato:</strong> Primeros 7 días de compra
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
            <Footer />
        </div></div>
    );
}